module.exports = __webpack_public_path__ + "static/media/WP-Snippet-04.3838983a.mp4";